mutation (
  $input: SendNewsOtpInput!
) {
  sendNewsOtp(
    input: $input
  )
}
